import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

// Technically this is not a service but a factory for MatPaginatorIntl (Service)
export class MatPaginatorI18n {
    constructor(private readonly translate: TranslateService) {
    }

    public getPaginatorIntl(): MatPaginatorIntl {
        const paginatorIntl: MatPaginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = this.translate.instant('sla-cost-accounting.paginator.items-per-page.label');
        paginatorIntl.nextPageLabel = this.translate.instant('sla-cost-accounting.paginator.next-page.label');
        paginatorIntl.previousPageLabel = this.translate.instant('sla-cost-accounting.paginator.previous-page.label');
        paginatorIntl.firstPageLabel = this.translate.instant('sla-cost-accounting.paginator.first-page.label');
        paginatorIntl.lastPageLabel = this.translate.instant('sla-cost-accounting.paginator.last-page.label');
        paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);
        return paginatorIntl;
    }

    private getRangeLabel(page: number, pageSize: number, length: number): string {
        if (length === 0 || pageSize === 0) {
            return this.translate.instant('sla-cost-accounting.paginator.range-page-1.label', { length });
        }
        length = Math.max(length, 0);
        const startIndex: number = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex: number = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return this.translate.instant('sla-cost-accounting.paginator.range-page-2.label', { startIndex: startIndex + 1, endIndex, length });
    }

}
